import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_STUDIO_API_URL || 'http://localhost:4173/api/studio/v1';

export type AstroLogoUsage = {
  isPremium: boolean;
  freeLimit: number;
  used: number;
  remaining: number | 'unlimited';
  totalGenerations: number;
  lastGeneratedAt: string | null;
};

export type AstroLogoPayload = {
  brandName: string;
  businessCategory: string;
  preferredStyle: string;
  lagna?: string;
  moonRashi?: string;
  moonNakshatra: string;
  nakshatraPada?: string;
  tithi?: string;
  vara?: string;
  yoga?: string;
  karana?: string;
  dominantPlanet: string;
  language?: 'en' | 'hi';
};

export async function getAstroLogoUsage() {
  const res = await axios.get(`${API_BASE_URL}/astro-logo/usage`);
  return res.data;
}

export async function generateAstroLogo(payload: AstroLogoPayload) {
  const res = await axios.post(`${API_BASE_URL}/astro-logo/generate`, payload);
  return res.data;
}
